import React from "react"
import PropTypes from "prop-types"

import { Dropdown } from "ui"
import WithObjects from "data/wrappers/WithObjects"

class ObjectPicker extends React.Component {
    render() {
        return (
            <WithObjects>
                {({ objects }) => {
                    return (
                        <Dropdown
                            onChange={this.props.onChange}
                            placeholder="Select data source"
                            clearable={false}
                            options={objectToOptions(objects || [])}
                            value={this.props.value}
                        />
                    )
                }}
            </WithObjects>
        )
    }
}

const objectToOptions = object => {
    return object.map(record => ({
        label: record.name,
        value: record._sid,
    }))
}

ObjectPicker.propTypes = {}

export default ObjectPicker



// WEBPACK FOOTER //
// ./src/features/studio/components/ObjectPicker.js